module.exports = __webpack_public_path__ + "static/img/red-gradient.aed6848.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/NikeWebGL/element/Menu/img/red-gradient.svg
// module id = 519
// module chunks = 0